import { useState } from 'react';
import {
    Grid,
    Button,
    Divider
} from '@mui/material';
import { useSelector } from 'react-redux';
import RofApplication from './RofApplication';
import RofApplicationMedia from './RofApplicationMedia';

export default function RofBiocharApplication() {
    const [selectedCategory, setSelectedCategory] = useState('Application Data');
    const { selectedProject } = useSelector(state => state.postFormData);
    const { id } = selectedProject || {}

    const categories = [
        'Application Data',
        'Application Media',
    ];

    return (
        <Grid container gap={3}>
            <Grid item xs={12} sx={{ display: 'flex', gap: 2 }}>
                {categories.map(category => (
                    <Button
                        key={category}
                        onClick={() => setSelectedCategory(category)}
                        variant={selectedCategory === category ? 'contained' : 'outlined'}
                    >
                        {category}
                    </Button>
                ))}
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12} sx={{ p: 2 }}>
                {selectedCategory === 'Application Data' &&
                    <RofApplication projectKey={id} />
                }
                {selectedCategory === 'Application Media' &&
                    <RofApplicationMedia projectKey={id} />
                }
            </Grid>
        </Grid>
    );

}


